import React from 'react';

const FormInput = ({ label, id, type, classes, name, handleChange }) => {

  return (
    <div className="form-group mb-4">
      <label className="font-weight-bold lead" htmlFor={id}>{label}</label>{(type === "tel") ? null : <span title="required" className="text-muted FontAwesome">*</span>}
      <input 
        type={type} 
        id={id}
        className={classes}
        name={name} 
        disabled={type === "file" ? true : false} 
        placeholder={(type === "number") ? 1 : null} 
        min={(type === "number") ? 1 : null} 
        onChange={(item) => handleChange(item)}
        required={(type === "tel") ? null : "required"}
      />
    </div>
  );
}

export default FormInput;